import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm'
import * as Sentry from "@sentry/browser"
import '@github/relative-time-element'
import sort from '@alpinejs/sort'
import './editor-customizations'
import editPage from './edit-page'

Sentry.init({
    dsn: window.sentry_dsn,
    release: window.sentry_release,
    environment: window.sentry_environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: window.sentry_traces_sample_rate,
});


Alpine.plugin(sort)

Alpine.data('editPage', editPage)

Livewire.start();
